import Table from "@/components/Table/table";
import { useColumnCalimItemsDefs } from "@/features/claimsummary/summary/constant/claimFormHeaderConst";
import {
  MotifButton,
  MotifErrorMessage,
  MotifIcon,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import {
  useGetCaseSummaryDataQuery,
  useGetClaimSummaryViewApiDataQuery,
  useDeleteClaimItemMutation,
  useGetClaimItemBySchemeIdQuery,
} from "@/services/claimSummary/caseSummaryReducer";
import { useParams } from "react-router-dom";
import { useCustomCellRenderers } from "@/features/claimsummary/summary/constant/customHeader";
import { useNavigate } from "react-router-dom";
import { IconoirWarningTriangle } from "@ey-xd/motif-icon";
import { useMemo, useState } from "react";
import { useCase } from "@/features/case/use-case";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { havingAddPermission } from "@/utility/common";
import {
  CANCEL_BUTTON_VARIANT,
  CONFIRM_BUTTON_VARIANT,
  CREATE_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import { customTableLoadingData } from "@/components/Table/CustomPaginationConstants";
import { useTrans } from "@/components/Functions/dateFunc";
import SelectBox from "@/components/Form/SelectBox/SelectBox";
import { useGetEffectiveSchemesQuery } from "@/pages/CaseDetail/Voting/votingReducer";

export const ClaimItems = ({ resolvedStatus }: any) => {
  const [selectedVersionId, setSelectedVersionId] = useState<string>("");

  const TitleComplement = ({
    ClaimItem,
    claimRefrence,
  }: {
    ClaimItem: string[];
    claimRefrence: string;
  }) => {
    const navigate = useNavigate();

    const { claimId, caseId, debtorId, creditorId } = useParams<{
      claimId: string;
      caseId: string;
      debtorId: string | undefined;
      creditorId: string | undefined;
    }>();
    const { data: dataSchemes, isLoading: isLoadingSchemes } =
      useGetEffectiveSchemesQuery({ caseId }, { skip: !caseId });
    const SCHEME_OPTIONS: any[] = useMemo(() => {
      if (dataSchemes && !isLoadingSchemes) {
        return dataSchemes.map((item: any) => {
          return {
            label: item?.name || "",
            value: item?.schemeVersionId || "",
          };
        });
      }
      return [];
    }, [isLoadingSchemes, dataSchemes]);
    const defaultOption = {
      label: t("pages.claims.claimIteamsTab.schemeDropDownPlaceHolder"),
      value: "",
    };
    const schemeOptions = [defaultOption, ...SCHEME_OPTIONS];

    return (
      <>
      <div className="motif-col-lg-3">
        <SelectBox 
          options={[...schemeOptions]}
          filter={schemeOptions.length > 5}
          value={selectedVersionId}
          onChange={(e: any) => {
            setSelectedVersionId(e);
          }}
        />
        </div>

        {havingAddPermission(ClaimItem) && (
          <MotifButton
          style={{height:"43px"}}
            onClick={() => {
              navigate(
                `/case/${caseId}/claim/details/create?navigatedFrom=${
                  creditorId ? "creditor" : debtorId ? "debtor" : "claim"
                }&navId=${
                  creditorId ? creditorId : debtorId ? debtorId : claimId
                }&claimReference=${claimRefrence}`,
                {
                  state: { claimId },
                }
              );
            }}
            size="small"
            type="submit"
            variant={CREATE_BUTTON_VARIANT}
            disabled={resolvedStatus}
          >
            {t("pages.claims.claimIteamsTab.addButton")}
          </MotifButton>
        )}
      </>
    );
  };
  const { claimId, caseId } = useParams<{
    claimId: string;
    caseId: string;
  }>();
  const { t } = useTranslation();
  const caseData = useCase(caseId, true);
  const columnCalimItemsDefs = useColumnCalimItemsDefs(caseData);
  const [claimItemId, setClaimItemId] = useState<any>("");
  const [claimItemReference, setclaimItemReference] = useState<any>("");
  const [showModal, setShowModal] = useState(false);
  const [showDeleteNotiy, setShowDeleteNotiy] = useState(false);
  // @ts-ignore
  const getDataByUrl = { caseId: caseId || caseData.caseId, claimId: claimId };
  const { data, error, isLoading, isFetching, refetch } =
    useGetCaseSummaryDataQuery(getDataByUrl);
  const { data: claimSummaryData } =
    useGetClaimSummaryViewApiDataQuery(claimId);
  let schemeRequsetBody = {
    schemeVersionId: selectedVersionId,
    claimId: claimId,
  };
  const { data: schemeFilterClassData, isFetching: fetchingClasses } =
    useGetClaimItemBySchemeIdQuery(schemeRequsetBody, {
      skip: !claimId || !selectedVersionId,
    });
  let claimItemsData: any = data?.claimItems
    ? JSON.parse(JSON.stringify(data.claimItems))
    : [];
  if (selectedVersionId) {
    claimItemsData?.forEach((item: any) => {
      const schemeFilter = schemeFilterClassData?.find(
        (scheme: any) => scheme.claimItemId === item.claimItemId
      );
      if (schemeFilter) {
        item.className = schemeFilter.className;
      }
    });
  } else {
    claimItemsData = data?.claimItems || [];
  }

  const [deleteClaimItemMutation, { isLoading: deleteLoading }] =
    useDeleteClaimItemMutation();
  const permissions = useSelector((state: any) => state.permissions);
  const { ClaimItem } = permissions;
  const transFunction = useTrans(
    t,
    t("pages.claims.claimIteamsTab.deletewarning", {
      claimItemReference: claimItemReference,
    }),
    "claimItemReference"
  );
  const caseRenderers = useCustomCellRenderers(
    caseId,
    setClaimItemId,
    setShowModal,
    resolvedStatus,
    ClaimItem,
    setclaimItemReference
  );
  const pinnedBottomRowData = [
    {
      columnField1: <></>,

      columnField8: (
        <>{t("pages.claims.claimIteamsTab.tablecolumns.columnTotal")}</>
      ),
      columnField3: <>{data && data?.claimItemTotalAmount?.totalOriginalAmt}</>,
      columnField4: (
        <>{data && data?.claimItemTotalAmount?.totalClaimItemCurrentAmt}</>
      ),
      columnField5: (
        <>
          {data && data?.claimItemTotalAmount?.totalLatestCreditorPositionAmt}
        </>
      ),
      columnField6: (
        <>{data && data?.claimItemTotalAmount?.totalLatestDebtorPositionAmt}</>
      ),
      columnField7: <>{data && data?.claimItemTotalAmount?.totalResolvedAmt}</>,
    },
  ];

  if (error) {
    return (
      <MotifErrorMessage
        style={{
          textAlign: "center",
          display: "block",
          alignItem: "center",
        }}
      >
        {t("global.globalNotifications.wentWrong")}
      </MotifErrorMessage>
    );
  }
  if (isLoading) {
    return <MotifProgressLoader show variant="default" />;
  }

  async function deleteClaimItem() {
    let jsonData = {
      claimItemId: claimItemId,
    };

    const response = await deleteClaimItemMutation(jsonData);
    if (response.hasOwnProperty("data")) {
      setShowModal(false);
      setShowDeleteNotiy(true);
      refetch();
    }
  }
  if (data && claimSummaryData && data?.claimItems) {
    return (
      <>
        <div className="mar-b-20">
          {showDeleteNotiy && (
            <div className="mar-b-20">
              <NotificationGrid
                show={true}
                message="pages.claims.claimIteamsTab.deleteMessage"
                type="success"
              />
            </div>
          )}
          <MotifModal
            onClose={() => setShowModal(false)}
            show={showModal}
            focusTrapOptions={{
              tabbableOptions: {
                displayCheck: "none",
              },
            }}
          >
            <div className="confirmationModalWrapper creditor_disabling_model">
              <MotifModalHeader
                headerIcon={
                  <>
                    <span
                      style={{
                        backgroundColor: "rgb(252, 245, 243)",
                        borderRadius: "50px",
                        padding: "5px 8px 2px 8px",
                      }}
                    >
                      <MotifIcon
                        iconFunction={IconoirWarningTriangle}
                        strokeWidth="1"
                        size="15"
                        stroke="red"
                      />{" "}
                    </span>
                    <span
                      style={{
                        fontSize: 16,
                        display: "block",
                        width: "100%",
                        marginLeft: "10px",
                      }}
                    >
                      {t("global.globalNotifications.warning")}
                    </span>
                  </>
                }
              ></MotifModalHeader>

              <MotifModalBody style={{ paddingTop: "0px" }}>
                <span style={{ fontWeight: "300" }}>
                  {claimItemId !== "" ? (
                    <span>{transFunction}</span>
                  ) : (
                    <span>
                      {t("pages.claims.claimIteamsTab.cannotDelete")}
                      <strong>{claimItemReference}</strong>
                      {" ."}
                    </span>
                  )}
                </span>
              </MotifModalBody>
              <MotifModalFooter>
                {claimItemId !== "" && (
                  <MotifButton
                    size="small"
                    type="submit"
                    variant={CONFIRM_BUTTON_VARIANT}
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                    onClick={deleteClaimItem}
                    loading={deleteLoading}
                  >
                    {t("global.globalActions.confirm")}
                  </MotifButton>
                )}

                <MotifButton
                  className=""
                  onClick={() => setShowModal(false)}
                  size="small"
                  type="button"
                  variant={CANCEL_BUTTON_VARIANT}
                >
                  {t("global.globalActions.cancel")}
                </MotifButton>
              </MotifModalFooter>
            </div>
          </MotifModal>
          <Table
            columnDefs={columnCalimItemsDefs}
            cellRenderers={isFetching || fetchingClasses ? [] : claimItemsData}
            TitleComplement={() => (
              <TitleComplement
                claimRefrence={
                  claimSummaryData?.claimSummary?.claimReference || ""
                }
                ClaimItem={ClaimItem}
              />
            )}
            title={"pages.claims.claimIteamsTab.tableTitle"}
            description={"pages.claims.claimIteamsTab.tableDescription"}
            caseRenderers={caseRenderers}
            pagination={false}
            pinnedBottomRowData={
              data?.claimItems &&
              data?.claimItems.length > 0 &&
              !(isFetching || fetchingClasses)
                ? pinnedBottomRowData
                : null
            }
            overlayNoRowsTemplate={
              isFetching || fetchingClasses
                ? t(customTableLoadingData)
                : error
                ? t("global.globalNotifications.wentWrong")
                : t("global.globalNotifications.noRecords")
            }
          />
        </div>
      </>
    );
  }
  return null;
};
